/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, TextStyle, Link, Icon } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';

import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import RenderColorPickerItem from 'src/components/views/common/render-color-picker-item';

import {
  DEFAULT_FONT_SIZE,
  IMAGE_SIZE_OPTIONS,
  MAX_FONT_SIZE_COLLECTION_TITLE
} from 'src/constants/theme-settings.js';
import TextForm from './text-form';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class CollectionHeaderTitleForm extends Component<ComposedProps> {
  state = {
    isOpenedCheckout: true,
    isOpenedViewCart: true
  };

  /**
   * Blur text field
   * @param {*} event
   * @param {*} value
   * @param {*} name
   */
  onBlurTextField = (event, value, name) => {
    const { updateField } = this.props;
    if (!value) {
      event.preventDefault();
      updateField(name, DEFAULT_FONT_SIZE);
    }
  };

  /**
   * Get layout option with translation label
   * @returns
   */
  getImageSizes = () => {
    const { i18n } = this.props;
    return IMAGE_SIZE_OPTIONS.map(option => {
      const { label, value } = option;

      return { label: i18n.translate(label), value };
    });
  };

  /**
   * Get color picker options
   * @returns
   */
  getColorPickers = (prefix: string) => {
    const { i18n, formValues } = this.props;

    return [
      {
        colorValue: _.get(formValues, `${prefix}.collectionTitleColor`),
        fieldName: `${prefix}.collectionTitleColor`,
        fieldLabel: i18n.translate('AdminHTML.ThemeSetting.Form.collectionHeaderTitle_Color_Item1')
      }
    ];
  };

  render() {
    const { i18n, prefix, updateField, formValues } = this.props;

    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.collectionHeaderTitle_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['CollectionTitleThemeSetting']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <div className="form-section">
          <p className="form-section__item form-section__item--medium-spacing title">
            {i18n.translate('AdminHTML.ThemeSetting.Form.color_Title')}
          </p>
          <div className="form-section__item">
            {this.getColorPickers(prefix).map((item, index) => (
              <RenderColorPickerItem
                key={index}
                colorValue={item.colorValue}
                fieldName={item.fieldName}
                fieldLabel={item.fieldLabel}
                updateField={updateField}
              />
            ))}
          </div>
        </div>
        <TextForm
          formValues={formValues}
          updateField={updateField}
          prefix={prefix}
          showTextAlignment
          showTextTransform
          maxFontSize={MAX_FONT_SIZE_COLLECTION_TITLE}
          customFieldNameAlignment={`${prefix}.textAlign`}
        />
      </FormLayout>
    );
  }
}

export default withI18n()(CollectionHeaderTitleForm);
